import GastroPosizionamentoBibList from "./pages/GastroPosizionamentoBibList.vue"
import GastroPosizionamentoBibView from "./pages/GastroPosizionamentoBibView.vue"
import GastroPosizionamentoBibEdit from "./pages/GastroPosizionamentoBibEdit.vue"

export default{
    GastroPosizionamentoBibList,
    GastroPosizionamentoBibView,
    GastroPosizionamentoBibEdit
}
